import { AudioInputSelectionPanel } from '@/components/AudioInputSelectionPanel/AudioInputSelectionPanel'
import MusicNoteIcon from '@/CustomIcons/MusicNoteIcon'
import { Card } from '../../Card'
import { CardHeader } from '../../CardHeader'

export function AdvancedInputsSection() {
    const subHeaderStyle = 't-base-light opacity-75'
    return (
        <Card className="flex flex-col gap-[20px]">
            <div className="grid grid-cols-[45%_1fr_33%]">
                <CardHeader icon={MusicNoteIcon} title="Audio Inputs" />
                <div className={subHeaderStyle}>Channels</div>
                <div className={subHeaderStyle}>Quality</div>
            </div>
            <AudioInputSelectionPanel noHeader />
        </Card>
    )
}
